import { iconMap } from '../use-amap/icon/iconMap/index'
import { debounce } from 'lodash-es'

// const throttleTime = 1500
const debounceTime = 500
// const makeMaker = (context, color) => {
//   // const factor = Math.pow(context.count / count, 1 / 18)
//   const div = document.createElement('div')
//   const Hue = 180 - factor * 180
//   const bgColor = 'hsla(' + Hue + ',100%,40%,0.7)'
//   const fontColor = 'hsla(' + Hue + ',100%,90%,1)'
//   const borderColor = 'hsla(' + Hue + ',100%,40%,1)'
//   const shadowColor = 'hsla(' + Hue + ',100%,90%,1)'
//   div.style.backgroundColor = bgColor
//   const size = Math.round(20)
//   // const size = Math.round(20 + Math.pow(context.count / count, 1 / 5) * 20)
//   div.style.width = div.style.height = size + 'px'
//   div.style.border = 'solid 1px ' + borderColor
//   div.style.borderRadius = size / 2 + 'px'
//   div.style.boxShadow = '0 0 5px ' + shadowColor
//   div.innerHTML = context.count
//   div.style.lineHeight = size + 'px'
//   div.style.color = fontColor
//   div.style.fontSize = '14px'
//   div.style.textAlign = 'center'
//   return div
// }

// const renderClusterMarker = () => (context) => {
//   const div = makeMaker()

//   context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2))
//   context.marker.setContent(div)
// }

const renderMarker = (onClickMarker, opts) => (context) => {
  // const icon = handleIcon(context, imageKey)
  // const icon = iconMap[context.data[0].extData.icon]
  if (opts.icon) {
    const icon = iconMap[opts.icon]
    if (icon) {
      context.marker.setIcon(
        new AMap.Icon({
          size: new AMap.Size(32, 32), // 图标尺寸
          image: icon, // Icon的图像
          imageSize: new AMap.Size(32, 32), // 根据所设置的大小拉伸或压缩图片
        })
      )
    }
  }

  context.marker.setTop(true)
  context.marker.setClickable(true)
  context.marker.on('click', () => {
    if (onClickMarker) {
      onClickMarker({
        count: context.count,
        data: context.data.map((x) => x.extData),
      })
    }
  })
}

export default function UseAmapCluster(
  opts = {
    gridSize: 60,
  }
) {
  // const setApis = (AMap, amap, layer) => {
  //   return {
  //     pushMarkers(markers, onClickMarker, optsLocal = {}) {
  //       new AMap.MarkerClusterer(amap, markers, {
  //         gridSize: optsLocal.gridSize || opts.gridSize,
  //         renderMarker: renderMarker(),
  //         renderClusterMarker: renderClusterMarker(onClickMarker),
  //       })
  //     },
  //   }
  // }
  const render = (AMap, amap, layer) => {
    return () => {
      // console.log('[2]', layer.legends)
      layer.legends.forEach((legend) => {
        const data = legend.dataQueue.pop()
        const renderData = []
        // console.log('[2]', legend, renderData)
        if (!legend.data) {
          legend.data = {}
        }
        data.forEach((datum) => {
          if (!legend.data[datum.objectId]) {
            renderData.push(datum)
          }
        })
        if (renderData.length === 0) {
          console.log('[use amap]', '无需渲染')
          return
        }
        const makers = renderData.map((x) => {
          return {
            lnglat: x.lnglat,
            extData: x,
          }
        })
        if (legend.clustererRender) {
          // console.log('[2]', legend.clustererRender)
          legend.clustererRender.addData(makers)
        } else {
          legend.clustererRender = new AMap.MarkerClusterer(amap, makers, {
            gridSize: opts.gridSize,
            renderMarker: renderMarker(layer.onClickMarker, {
              icon: legend.markerIcon,
            }),
            // renderClusterMarker: renderClusterMarker(onClickMarker),
          })
          window.cluster = legend.clustererRender
        }
        renderData.forEach((datum) => {
          legend.data[datum.objectId] = datum
        })
      })
    }
  }

  const clear = (AMap, amap, layer) => {
    return () => {
      Object.values(layer.clusterers).forEach((x) => {
        x.clearMarkers()
      })
    }
  }

  const init = (AMap, amap, layer) => {
    layer.render = render(AMap, amap, layer)
    layer.clusterers = {}
    layer.clear = clear(AMap, amap, layer)
  }

  const makeBounds = (bounds) => {
    return [
      [bounds.northEast.lng, bounds.northEast.lat],
      [bounds.southWest.lng, bounds.northEast.lat],
      [bounds.southWest.lng, bounds.southWest.lat],
      [bounds.northEast.lng, bounds.southWest.lat],
      [bounds.northEast.lng, bounds.northEast.lat],
    ]
  }

  // 没有细考虑亚洲以外
  const makeBounds2 = (bounds1, bounds2) => {
    if (bounds1.northEast.lng <= bounds2.northEast.lng) {
      if (bounds2.southWest.lng <= bounds1.southWest.lng) {
        return makeBounds(bounds2)
      }
      if (bounds1.northEast.lat <= bounds2.northEast.lat) {
        // 东 北 向
        return [
          [bounds2.southWest.lng, bounds2.northEast.lat],
          [bounds2.northEast.lng, bounds2.northEast.lat],
          [bounds2.northEast.lng, bounds2.southWest.lat],
          [bounds1.northEast.lng, bounds2.southWest.lat],
          [bounds1.northEast.lng, bounds1.northEast.lat],
          [bounds2.southWest.lng, bounds1.northEast.lat],
          [bounds2.southWest.lng, bounds2.northEast.lat],
        ]
      }
      // 东 南 向
      return [
        [bounds1.northEast.lng, bounds2.northEast.lat],
        [bounds2.northEast.lng, bounds2.northEast.lat],
        [bounds2.northEast.lng, bounds2.southWest.lat],
        [bounds2.southWest.lng, bounds2.southWest.lat],
        [bounds2.southWest.lng, bounds1.southWest.lat],
        [bounds1.northEast.lng, bounds1.southWest.lat],
        [bounds1.northEast.lng, bounds2.northEast.lat],
      ]
    } else {
      if (bounds1.northEast.lat <= bounds2.northEast.lat) {
        // 西 北 向
        return [
          [bounds2.southWest.lng, bounds2.northEast.lat],
          [bounds2.northEast.lng, bounds2.northEast.lat],
          [bounds2.northEast.lng, bounds1.northEast.lat],

          [bounds1.southWest.lng, bounds1.northEast.lat],
          [bounds1.southWest.lng, bounds2.southWest.lat],
          [bounds2.southWest.lng, bounds2.southWest.lat],
          [bounds2.southWest.lng, bounds2.northEast.lat],
        ]
      }
      // 西 南 向
      return [
        [bounds2.southWest.lng, bounds2.northEast.lat],
        [bounds1.southWest.lng, bounds2.northEast.lat],
        [bounds1.southWest.lng, bounds1.southWest.lat],

        [bounds2.northEast.lng, bounds1.southWest.lat],
        [bounds2.northEast.lng, bounds2.southWest.lat],
        [bounds2.southWest.lng, bounds2.southWest.lat],
        [bounds2.southWest.lng, bounds2.northEast.lat],
      ]
    }
  }

  const getBounds = (AMap, amap, layer) => {
    return () => {
      let bounds = makeBounds(amap.getBounds())
      // console.log(makeBounds2)

      if (amap.clBounds) {
        // amap.getBounds()
        // console.log(
        //   '[use amap]',
        //   JSON.stringify(makeBounds2(amap.clBounds, amap.getBounds()))
        // )
        bounds = makeBounds2(amap.clBounds, amap.getBounds())
      }
      amap.clBounds = amap.getBounds()
      return bounds
    }
  }

  const renderCluster = (AMap, amap, layer) => {
    return () => {
      layer.getData().then((newData) => layer.render(newData))
    }
  }

  const reset = (AMap, amap, layer) => {
    return () => {
      layer.legends.forEach((legend) => {
        legend.data = {}
        legend.clustererRender = null
      })
      amap.clBounds = null
      amap.clzoom = null
      amap.clearMap()
    }
  }

  const setApis = (AMap, amap) => {
    return {
      initCluster: (layer, extFunc) => {
        layer.render = render(AMap, amap, layer)
        layer.clusterers = {}
        layer.clear = clear(AMap, amap, layer)
        // layer.getDataByLegend = getDataByLegend(AMap, amap, layer)
        layer.getBounds = getBounds(AMap, amap, layer)
        layer.reset = reset(AMap, amap, layer)
        layer.renderCluster = renderCluster(AMap, amap, layer)

        // 方案 1)
        //     dragend 会漏掉一些时间，比如通过 api set center 时
        //     resize, touchend 时，也会漏掉
        //     setCenter 自己包装下，setCenter 结束后调用 renderCluster
        // 方案 2)
        //     或者用 moveend，然后比较 zoom，如果 zoom 有变化说明可能不是平移
        //     会不会有些许漏洞

        // 另外平移结束时其实可以比较下和上次的四至有没有重叠，然后抠除重叠的部分
        // 方案 1:
        amap.on(
          'moveend',
          debounce(
            () => {
              if (amap.clzoom && amap.clzoom < amap.getZoom()) {
                amap.clzoom = amap.getZoom()
                return
              }
              amap.clzoom = amap.getZoom()
              layer.renderCluster()
            },
            debounceTime,
            { leading: false, trailing: true }
          )
        )

        // 方案 2:
        // amap.on(
        //   'dragend',
        //   throttle(
        //     () => {
        //       layer.renderCluster()
        //     },
        //     throttleTime,
        //     { trailing: false }
        //   )
        // )
        // amap.on(
        //   'zoomend',
        //   throttle(
        //     () => {
        //       // 当 zoom 变大时不用重新获取数据
        //       if (amap.clzoom && amap.clzoom <= amap.getZoom()) {
        //         amap.clzoom = amap.getZoom()
        //         return
        //       }
        //       amap.clzoom = amap.getZoom()
        //       layer.renderCluster()
        //     },
        //     throttleTime,
        //     { trailing: false }
        //   )
        // )

        if (extFunc) {
          extFunc(layer)
        }
        return layer
      },
      initCluster2: (layer, extFunc) => {
        layer.render = render(AMap, amap, layer)
        layer.clusterers = {}
        layer.clear = clear(AMap, amap, layer)
        // layer.getDataByLegend = getDataByLegend(AMap, amap, layer)
        layer.getBounds = getBounds(AMap, amap, layer)
        layer.reset = reset(AMap, amap, layer)
        layer.renderCluster = renderCluster(AMap, amap, layer)

        if (extFunc) {
          extFunc(layer)
        }
        return layer
      },
    }
  }

  return {
    amapPlugins: ['AMap.MarkerClusterer'],
    init,
    setApis,
  }
}
